import React, { Component } from 'react'
import { Marker, InfoWindow } from 'react-google-maps'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Button, Icon, Paper, IconButton } from '@material-ui/core'
import ColorButton from './ColorButton'
import { blue } from '@material-ui/core/colors'
import {
    FilterMobilitätsbehinderung,
    FilterGehörlos,
    FilterHörbehinderung,
    FilterSehbehinderung,
    FilterGeistigeBehinderung
} from './modules/filters'
import { FONT_SIZE_REGULAR, FONT_SIZE_BIG } from './modules/options'
import Modal from '@material-ui/core/Modal'
import {
    MobilitätsbehinderungDescription,
    GehörlosDescription,
    HörbehinderungDescription,
    SehbehinderungDescription,
    GeistigeBehinderungDescription
} from './Descriptions'
import { StyledReactMarkdown } from './styles'
import officeAsset from './assets/office.png'
import meetingAsset from './assets/meeting.png'
import churchAsset from './assets/church.png'
import gehoerlosAsset from './assets/church.png'

const MenuButton = styled(ColorButton)`
    margin-right: 1rem;
    box-shadow: none;
`

const MenuIcon = styled(Icon)`
    font-size: 2.5rem;
`

const Name = styled.div`
    font-size: 1.6em;
    margin-top: 0.3rem;
`

const Text = styled.div`
    font-size: 1.2em;
`

const Header = styled.div`
    font-size: 1.3em;
    font-weight: bold;
    margin-top: 1rem;
    margin-bottom: 0.5rem;
`

const BarrierefreiPaper = styled(Paper)`
    position: relative;
    margin: 6rem 0;
    padding: 3rem;
    max-width: 80%;
`

const CloseIconButton = styled(IconButton)`
    width: 3.5rem;
    height: 3.5rem;
    position: absolute;
    right: 0.5rem;
    top: 0.5rem;
`

const CloseButton = styled(Button)`
    float: right;
`

const BarrierefreiModal = styled(Modal)`
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: scroll;
`

const Details = styled.div`
    font-size: ${props => props.fontsize};
`

class PlaceMarker extends Component {
    state = {
        isOpen: false,
        modalIsOpen: false
    }

    toggleOpen = () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }

    handleClose = () => {
        this.setState({ modalIsOpen: false })
    }

    barrierefreiItem = filter => {
        const icon = this.props.filters.find(x => x.filter === filter).icon

        return (
            <MenuButton
                mini
                variant="fab"
                csscolor={blue}
                colorlevel={600}
                onClick={() => {
                    this.setState({
                        modalIsOpen: true,
                        modalBehinderung: filter
                    })
                }}
            >
                <MenuIcon>{icon}</MenuIcon>
            </MenuButton>
        )
    }

    description = () => {
        switch (this.state.modalBehinderung) {
            case FilterMobilitätsbehinderung:
                return MobilitätsbehinderungDescription
            case FilterGehörlos:
                return GehörlosDescription
            case FilterHörbehinderung:
                return HörbehinderungDescription
            case FilterSehbehinderung:
                return SehbehinderungDescription
            case FilterGeistigeBehinderung:
                return GeistigeBehinderungDescription
            default:
                return null
        }
    }

    markerIcon = () => {
        switch (this.props.kategorie) {
            case '':
                return churchAsset
            case 'Krankenhaus':
                return meetingAsset
            case 'Ort im Freien':
                return meetingAsset
            case 'Servicezentrum/Altenheim':
                return officeAsset
            case 'Kirche/Kapelle in gastweiser Nutzung':
                return churchAsset
            case 'Sonstiger Ort':
                return meetingAsset
            case 'Kindertagesstätte/Kindergarten':
                return meetingAsset
            case 'Kirche/Kapelle des Veranstalters':
                return churchAsset
            case 'Familienbildungsstätte/Akademie/Tagungshaus':
                return meetingAsset
            case 'Gemeindehaus/Gemeindezentrum':
                return churchAsset
            default:
                return churchAsset
        }
    }

    fontSize = () => {
        switch (this.props.fontSize) {
            case FONT_SIZE_REGULAR:
                return '100%'
            case FONT_SIZE_BIG:
                return '120%'
            default:
                return '100%'
        }
    }

    render() {
        const {
            name,
            strasse,
            plz,
            ort,
            region,
            mobilitätsbehinderung,
            gehörlos,
            hörbehinderung,
            sehbehinderung,
            geistigeBehinderung
        } = this.props

        const behinderungItems = [
            mobilitätsbehinderung,
            gehörlos,
            hörbehinderung,
            sehbehinderung,
            geistigeBehinderung
        ]

        const fontSize = this.fontSize()

        return (
            <Marker
                icon={this.markerIcon()}
                position={{ lat: this.props.lat, lng: this.props.long }}
                onClick={this.toggleOpen}
                noRedraw
            >
                {this.state.isOpen && (
                    <InfoWindow onCloseClick={this.toggleOpen}>
                        <Details fontsize={fontSize}>
                            <Name>{name}</Name>

                            {behinderungItems.some(x => x) && (
                                <React.Fragment>
                                    <Header>Barrierefrei</Header>

                                    {mobilitätsbehinderung &&
                                        this.barrierefreiItem(
                                            FilterMobilitätsbehinderung
                                        )}
                                    {gehörlos &&
                                        this.barrierefreiItem(FilterGehörlos)}
                                    {hörbehinderung &&
                                        this.barrierefreiItem(
                                            FilterHörbehinderung
                                        )}
                                    {sehbehinderung &&
                                        this.barrierefreiItem(
                                            FilterSehbehinderung
                                        )}
                                    {geistigeBehinderung &&
                                        this.barrierefreiItem(
                                            FilterGeistigeBehinderung
                                        )}
                                </React.Fragment>
                            )}

                            <Header>Anschrift</Header>
                            <Text>{strasse}</Text>
                            <Text>
                                {plz} {ort}
                            </Text>

                            {region.length > 0 && (
                                <React.Fragment>
                                    <Header>Region</Header>
                                    <Text>{region}</Text>
                                </React.Fragment>
                            )}
                        </Details>
                    </InfoWindow>
                )}

                <BarrierefreiModal
                    disableAutoFocus
                    open={this.state.modalIsOpen}
                    onClose={this.handleClose}
                >
                    <BarrierefreiPaper>
                        <StyledReactMarkdown
                            fontsize={fontSize}
                            source={this.description()}
                        />
                        <CloseIconButton onClick={this.handleClose}>
                            <Icon>close</Icon>
                        </CloseIconButton>
                        <CloseButton
                            variant="raised"
                            color="primary"
                            onClick={this.handleClose}
                        >
                            schließen
                        </CloseButton>
                    </BarrierefreiPaper>
                </BarrierefreiModal>
            </Marker>
        )
    }
}

export default connect(
    state => ({
        filters: state.filters,
        fontSize: state.options.fontSize
    }),
    dispatch => bindActionCreators({}, dispatch)
)(PlaceMarker)



// WEBPACK FOOTER //
// ./src/PlaceMarker.js